import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { useGetStripePlanDetailQuery } from "../../service/stripe/api";
import moment from "moment";

const PackageDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isLoading } = useGetStripePlanDetailQuery(id);

  const plan = data?.data;

  const packageInfo = plan ? [
    { label: "Package Name / اسم الباقة", value: plan.name },
    { label: "Price / السعر", value: `${plan.currency?.toUpperCase()} ${plan.amount}` },
    { label: "Interval / المدة", value: plan.interval },
    { label: "Created Date / تاريخ الإنشاء", value: moment(plan.createdAt).format("DD MMMM YYYY") },
  ] : [];

  const features = plan?.features || [];

  return (
    <>
      {/* Page Title */}
      <CommonBreadcrumb
        title="Package Detail / تفاصيل الباقة"
        breadcrumbItems={[
          { label: "Dashboard / لوحة المعلومات", onClick: () => navigate("/dashboard") },
          { label: "Manage Packages / إدارة الباقات", onClick: () => navigate("/manage-packages") },
          { label: "Package Detail / تفاصيل الباقة" },
        ]}
      />

      <div className="cards view_page">
        {isLoading ? (
          <div className="gap_p">Loading... / جارٍ التحميل...</div>
        ) : !plan ? (
          <div className="gap_p">Plan not found. / لم يتم العثور على الباقة.</div>
        ) : (
          <div className="gap_p">
            {packageInfo.map((item, index) => (
              <div className="w_33" key={index}>
                <h6>{item.label}</h6>
                <p>{item.value}</p>
              </div>
            ))}

            {/* Features Section */}
            <div className="w_100">
              <h6>Features / الميزات</h6>
              <ul className="feature_list">
                {features.map((feature: any, index: number) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PackageDetail;
